import { useEffect, useState } from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import CustomizedDialogs from "../../atoms/dialog";
import SortableTree from 'react-sortable-tree';
import { generateFieldTreeJson, generateFieldEventTreeJson } from "../../../services/blueprint";
import UpdateCancel from "../../atoms/buttons/UpdateCancel";
import { invokeGetService, handleSnackBar } from '../../../store/global/actions';
import { useDispatch } from 'react-redux';
import LoaderWithProgress from "../../atoms/loader/LoaderWithProgress.js"
import TransactionManager from '../../../services/transactionManager.js'
import 'react-sortable-tree/style.css';

export default function FieldMappingTree({ open, onClose, onCompletion, schemaValues, selectedTransaction }) {
    const dispatch = useDispatch()
    const mappedField = schemaValues?.transaction?.field;
    const [tree, setTree] = useState(null);
    const [clickedNode, setClickedNode] = useState({ tagLabel: mappedField });
    const [loading, setLoading] = useState(true);
    const [selectedItem, setSelectedItem] = useState('');
    const [messages, setMessages] = useState([]);

    useEffect(() => {

        setBasicRequirements()
            .then(({ clusterlets, transactions, events, messages, fields, sections }) => {
                setMessages(messages ? messages : []);
                if (selectedTransaction !== null) {
                    let selectedTransactionMappingValues = []
                    if (selectedTransaction !== undefined && !selectedTransaction?.hasOwnProperty('select')) selectedTransactionMappingValues = Object.keys(selectedTransaction)


                    if (transactions.map(tr => tr._id).includes(selectedTransactionMappingValues[0])) {
                        const transactionManager = new TransactionManager({ clusterlets, transactions, events, messages, fields })
                        const responseEventMsg = transactionManager.generateResponseEventMessages(selectedTransactionMappingValues[0])
                        console.log({responseEventMsg})
                        const mapped = selectedTransaction.field
                        let fieldTree = generateFieldEventTreeJson(responseEventMsg, fields, messages, mapped);
                        setTree(fieldTree);
                        setLoading(false);
                        setSelectedItem((transactions.find(tr => tr._id == selectedTransactionMappingValues[0])).name)
                    }
                    else {
                        let fieldTree = generateFieldTreeJson(selectedTransactionMappingValues[0], sections, fields, mappedField);
                        setTree(fieldTree);
                        setLoading(false);
                        setSelectedItem(clusterlets.find(c => c._id.toString() == selectedTransactionMappingValues[0])?.name)
                    }

                }
            })


    }, [])

    const setBasicRequirements = () => {
        setLoading(true)
        return new Promise((resolve, reject) => {
            dispatch(invokeGetService('viewMappingTreeDependencies', []))
                .then(response => {
                    if (response.status) {
                        resolve({ ...response })
                    } else {
                        setLoading(false);
                    }
                });
        });
    }



    const handleNodeClick = (event, node) => {
        if (node.disabled === true) {
            dispatch(handleSnackBar({ open: true, message: "Event type can't be selected", severity: 'error' }));
            return;
        }
        setClickedNode(node);
    }
    const onContinue = () => {
        onCompletion(clickedNode);
    }


    return (
        <>
            <CustomizedDialogs
                open={open}
                title={
                    (selectedItem && selectedItem.length > 0) ? (
                        `Select field from ${selectedItem}`
                    ) :
                        (
                            `Select field from ${selectedTransaction.event != undefined ? "Event" : "Clusterlet"}`
                        )
                }
                handleClose={onClose}
                paperProps={{ id: "fieldMappingTreeModal" }}
            >
                {loading ?
                    <Grid item xs={12}>
                        <LoaderWithProgress size={20} isContent={true} />
                    </Grid>

                    : tree !== null && tree.length > 0 ?
                        <SortableTree
                            treeData={tree}
                            isVirtualized={false}
                            canDrag={false}
                            onChange={treeData => setTree(treeData)}
                            generateNodeProps={(rowInfo) => {
                                const { node } = rowInfo;
                                let nodeProps = {
                                    title: (<TreeTitle node={node} messages={messages} />),
                                    onClick: (event) => handleNodeClick(event, node),
                                    style: { cursor: 'pointer', minWidth: 450 }
                                };
                                if (clickedNode !== null && node.tagLabel === clickedNode?.tagLabel && node.disabled !== true) {
                                    nodeProps.className = 'selected-field-node';
                                }
                                return nodeProps
                            }}
                            style={{ overflow: "auto hidden", minHeight: "70vh" }}

                        /> :
                        <Grid item xs={12}>
                            {selectedTransaction && <Typography variant='subtitle2'>
                                No events in the selected transaction
                            </Typography>}
                        </Grid>
                }
                <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                    <UpdateCancel onUpdate={onContinue} onCancel={onClose} content="Continue" />
                </Grid>
            </CustomizedDialogs>



        </>
    )
}

const TreeTitle = ({ node, messages }) => {
    const messageObj = messages.find(item => item._id.toString() === node?.attributes?.type);
    const nodeType = node.type === 11 ? 'PROPERTY' : messageObj ? messageObj.name : node?.attributes?.type?.toUpperCase();

    return (
        <Grid id={`node-item-${node?.title}`} container spacing={1}>
            <Grid xs={12}>
                {node?.title}
            </Grid>
            <Grid container xs={12}>
                <Typography style={{ fontSize: 10 }}>{nodeType}</Typography>
            </Grid>

        </Grid>
    )

}
